import {
  AUDIO_TYPES_ACCEPTED,
  EMAIL_REGEX,
  EMPTY_STRING,
  EXTENSION_ZIP,
  MAX_FILE_SIZE_IN_BYTES,
} from '../../constants/constants';

/**
 * Checks if file type is valid.
 * @param {string} fileType - The file type.
 * @return {boolean} - Returns the type validity.
 * */
export const isInvalidFileType = fileType => !AUDIO_TYPES_ACCEPTED.includes(fileType);

/**
 * Checks if file size is valid.
 * @param {number} fileSize - The file size.
 * @return {boolean} - Returns the size validity.
 * */
export const fileTooLarge = fileSize => fileSize > MAX_FILE_SIZE_IN_BYTES;

/**
 * Formats the numeric date to short string date
 * @param {number} numericDate - The numeric date.
 * @return {string} date - The formated date.
 * */
export const formatNumericDateToString = numericDate => new Date(numericDate * 1000).toLocaleDateString();

/**
 * Formats the numeric date to ISO string
 * @param {number} numericDate - The numeric date.
 * @return {string} date - The formated date.
 * */
export const formatNumericDateToISOString = numericDate => new Date(numericDate * 1000).toISOString();


/**
 * Formats the duration to HHMMSS string. Max duration is 24 hours
 * @param {number} seconds - The time in seconds.
 * @return {string} duration - The formated duration.
 * */
export const formatDurationToHHMMSS = seconds => new Date(seconds * 1000).toISOString().substr(11, 8);

/** Debounce a function callback as long as you need.
 * @param {function} callback - The callback function.
 * @param {number} wait - The delay number.
 * @return {function} - Returns debounce function.
 * */
export const debounce = (callback, wait) => {
  let timeout;

  return (...args) => {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(() => callback.apply(context, args), wait);
  };
};

/**
 * Removes the filename extension.
 * @param {string} filename - The file name.
 * @return {string} - Returns the file name without extension.
 * */
export const removeFileExtension = filename => filename.replace(/\.[^/.]+$/, EMPTY_STRING);

/**
 * Get the file extension.
 * @param {string} filename - The file name.
 * @return {string} - Returns the file extension.
 * */
export const getFileExtension = filename => filename.substr(filename.lastIndexOf('.') + 1);


/**
  * Check if user vertical scoll bar focus is at the end of list.
  * @param {object} container - The html container object.
  * @return {bool}
  * */
export const isVericalScrollBarAtBottom = (container) => {
  const scrollY = container.scrollHeight - container.scrollTop;
  const height = container.offsetHeight;
  const offset = height - scrollY;

  return (offset >= 0 && offset < 5);
};

/**
  * Add new items to array if they are not part of it
  * @param {array} existingItems - The existing array where to add.
  * @param {array} newItems - The array of items to add.
  * @return {array} The updated array with new items.
  * */
export const addItemsToArrayIfTheyDontExist = (existingItems, newItems) => {
  newItems.forEach((newItem) => {
    if (!existingItems.find(item => item.id === newItem.id)) {
      existingItems.push(newItem);
    }
  });

  return existingItems;
};

/**
 * Checks if the email address is valid.
 * @param {string} email - The email address.
 * @return {boolean} - The validation value.
 * */
export const isEmailValid = (email = null) => EMAIL_REGEX.test(email);

/**
 * Checks if the value exceeds mas length
 * @param {string} value - The value to check
 * @param {number} maxLength - The lenght limit
 * @return {boolean} - The validation value.
 * */
export const exceedsMaxLength = (value, maxLength) => value.length > maxLength;

/**
 * Checks if user enteres from Non Safari browser on iOS mobile .
 * @param {object} navigator - The navigator.
 * @param {object} window - The window.
 * @return {boolean} - The validation value.
 * */
export const isiOSMobileButNotSafari = (navigator, window) => {
  // eslint-disable-next-line
  const isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
  const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

  return (!isSafari && iOS);
};

/**
 * Checks if string contains only space chars
 * @param {string} string - The string to check.
 * @return {boolean} - The validation value.
 * */
export const isOnlySpaceString = string => (!string.replace(/\s/g, '').length);

/**
 * Get the download messages file name.
 * @return {string} - Returns the file extension.
 * */
export const getDownloadMessagesFileName = `Messages_${new Date().toLocaleDateString()}${EXTENSION_ZIP}`;



// WEBPACK FOOTER //
// ./src/common/helpers/common.helpers.js